import returnAppConfig from '@/helpers/return-app-config';
import engine from 'store/src/store-engine';

import localStorage from 'store/storages/localStorage';
import sessionStorage from 'store/storages/sessionStorage';
import defaultsPlugin from 'store/plugins/defaults';


export function merchantNamespacing() {
  const { merchantId } = returnAppConfig();

  return {
    get(superFn, key) {
      return superFn(`${merchantId}-${key}`);
    },

    remove(superFn, key) {
      return superFn(`${merchantId}-${key}`);
    },

    set(superFn, key, value) {
      return superFn(`${merchantId}-${key}`, value);
    }
  };
}

const createCookieStorage = () => {
  const { merchantId } = returnAppConfig();

  return {
    get(key) {
      const name = `${merchantId}-${key}=`;

      const ca = document.cookie.split(';');

      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }

        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }
  };
};


const storage = {
  cookie: createCookieStorage(),
  local: engine.createStore([localStorage], [defaultsPlugin, merchantNamespacing]),
  session: engine.createStore([sessionStorage], [defaultsPlugin, merchantNamespacing])
};



export default storage;
